import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetCategories_categoryId_StoreFixtures = "/categories/:categoryId/store-fixtures";

export type ParamsGetCategories_categoryId_StoreFixtures = ExtractRouteParams<
  typeof RouteGetCategories_categoryId_StoreFixtures
>;

export interface ResponseGetCategories_categoryId_StoreFixtures {
  storeId: number;
  storeCode: string;
  baySize: number;
}
